import React, { Component, useCallback, useEffect, useRef, useState} from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { Dropdown, Navbar, Container, Row, Button, Col, Table, Spinner, Card, Form, Nav } from 'react-bootstrap'
import { key_local_storage_cart, key_local_storage_pedidos, key_local_storage_user, urlapi } from '../../lib/backend/data'
import DireccionUsuario from './ingresoDireccion'
import useIsMobile from '../../subComponents/general/isMobile'
import { Link } from 'react-router-dom'
import CategoriasSelector from '../../subComponents/categorias/categorias_productos'
import FreeShippingCalculator from '../../subComponents/ordenes/despacho/cotizacionDespacho'
import { calculateTotalCart } from '../../lib/helpers/main'

const Header = (props) => {
  const {
    searchBox,
    cart
  } = props
    let carrito = props.carrito ? props.carrito : []
    const sitio = useSelector(state => state.sitio)
    const cart_ = useSelector(state => state.cart)
    const isMobile = useIsMobile()

    const onSelect = (data) => {
        if(props.onSelectCategory) props.onSelectCategory(data)
    }

    useEffect(() => {
      
        if(carrito.length < 1){
            if(localStorage.getItem(key_local_storage_cart)){
                const parseCart = JSON.parse(localStorage.getItem(key_local_storage_cart))
                carrito = parseCart
            }
        }

    }, [])
    
    const style_ = { verticalAlign: "top" }
    const subtotal = calculateTotalCart(cart_)
    return <>
      <FreeShippingCalculator total={subtotal} />
      <Navbar expand="md" bg="white" className="border-bottom p-4 sticky-top">
        <Container fluid className='d-flex justify-content-between'>
        {isMobile ? <div>
          {searchBox ? <div style={{ ...style_ }} className='d-inline-block'>{searchBox}</div> : false}
        {cart ? <div style={{ ...style_ }} className='d-inline-block'>{cart}</div> : false}
        <div style={{ ...style_ }} className='d-inline-block'><DireccionUsuario typeView="icon" /></div>
      </div> : false}
          <Navbar.Brand href="/">
            {sitio.logo ? (
              <img
                src={sitio.logo}
                alt="Logo"
                style={{ maxHeight: 50, maxWidth: "100%" }}
              />
            ) : (
              sitio.titulo
            )}
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarResponsive" />
          <Navbar.Collapse>
          <Nav className='pl-3 pr-3' style={{ margin: "0 auto" }}>
          <Link to="/" className={"nav-link mr-5"}>Tienda</Link>
          <CategoriasSelector typeView="menu" onSelect={(data) => onSelect(data)} />
          <Link to="/business" className={"nav-link mr-5"}>Venta Empresa</Link>
          <Link to="/nosotros" className={"nav-link mr-5"}>Origen</Link>
          <Link to="/contacto" className={"nav-link mr-5"}>Contacto</Link>
            </Nav>
            {
              !isMobile ? <div>
            <div style={{ ...style_ }} className='d-inline-block'><DireccionUsuario typeView="icon" /></div>
            {searchBox ? <div style={{ ...style_ }} className='d-inline-block'>{searchBox}</div> : false}
            {cart ? <div style={{ ...style_ }} className='d-inline-block'>{cart}</div> : false}
          </div> : null
            }
          
          </Navbar.Collapse>
        </Container>
      </Navbar>
      </>
}

export default Header